import { Tag, TagProps } from "@chakra-ui/react";
import { ReceivedEmailMessageCategoryType } from "__generated__/gql/graphql";
import { RECEIVED_EMAIL_CATEGORY_LABELS } from "utils/receivedEmailCategories";

const COLOR_SCHEME_BY_CATEGORY: Record<
  ReceivedEmailMessageCategoryType,
  string
> = {
  [ReceivedEmailMessageCategoryType.ANALYTICS_DATA]: "blue",
  [ReceivedEmailMessageCategoryType.PURCHASE_ORDERS]: "orange",
};

type Props = Omit<TagProps, "children"> & {
  category: ReceivedEmailMessageCategoryType;
};

export default function ReceivedEmailCategoryTag({ category, ...rest }: Props) {
  return (
    <Tag
      variant="subtle"
      colorScheme={COLOR_SCHEME_BY_CATEGORY[category]}
      {...rest}
    >
      {RECEIVED_EMAIL_CATEGORY_LABELS[category]}
    </Tag>
  );
}
